import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import BrandArticles from "./BrandArticles";
import apiConfig from "../../apiConfig";
import { fetchLocationInfo } from "../../features/shopLocation/locationSlice";

const StaffDiscountNoticeModal = ({
  isOpen,
  onClose,
  message,
  availableBranches,
  onLocationChange,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay DATENSCHUTZ Impressum">
      <div
        className="modal"
        style={{
          display: "block",
          marginTop: "180px",
          width: "50%",
          maxHeight: "320px",
          maxWidth: "50%",
        }}
      >
        <div
          className="col-md-8"
          style={{
            width: "100%",
            textAlign: "left",
            margin: "0 auto",
            background: "white",
            padding: "45px",
          }}
        >
          <div className="modal_head">
            <button className="close-btn" onClick={onClose}>
              Schließen
            </button>
          </div>

          <span className="datenbereich width_100 nopadding nomargin">
            <span
              className="datenbereich width_100 nopadding margin_bottom_3"
              style={{
                paddingLeft: "20px",
                paddingRight: "20px",
              }}
            >
              <label className="title main top">PERSONALKAUFTAGE</label>

              <div className="text-wrap first">
                <div className="modal_block">
                  <p>{message}</p>

                  {availableBranches.length > 0 && (
                    <div className="mt-3">
                      <label className="mb-2">
                        <label class="title main top mb-0 small">
                          Filiale auswählen
                        </label>
                      </label>

                      <select
                        className="form-control"
                        defaultValue=""
                        onChange={(event) => {
                          if (event.target.value) {
                            onLocationChange(event.target.value);
                          }
                        }}
                      >
                        <option value="">Bitte Filiale auswählen</option>

                        {availableBranches.map((branch) => (
                          <option key={branch.value} value={branch.value}>
                            {branch.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>
              </div>
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

function StaffDiscount() {
  let { cat } = useParams();
  let { filter } = useParams();

  const dispatch = useDispatch();

  const [ArticlesList, setArticlesList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [availableBranches, setAvailableBranches] = useState([]);
  const [noticeModal, setNoticeModal] = useState({
    open: false,
    message: "",
  });

  const reduxLocation = useSelector((state) => state?.location?.value);

  const getSavedLocation = () => {
    const savedLocation = localStorage.getItem("selectLocation");

    if (savedLocation) {
      try {
        return JSON.parse(savedLocation);
      } catch (error) {
        return null;
      }
    }

    return null;
  };

  const [selectedLocation, setSelectedLocation] = useState(
    reduxLocation?.ORT ? reduxLocation : getSavedLocation(),
  );

  useEffect(() => {
    if (reduxLocation?.ORT) {
      setSelectedLocation(reduxLocation);
    }
  }, [reduxLocation]);

  useEffect(() => {
    const handleLocationChange = (event) => {
      console.log("StaffDiscount location changed:", event.detail);
      setSelectedLocation(event.detail);
    };

    window.addEventListener(
      "technikkennerLocationChanged",
      handleLocationChange,
    );

    return () => {
      window.removeEventListener(
        "technikkennerLocationChanged",
        handleLocationChange,
      );
    };
  }, []);

  const selectedLocationName = selectedLocation?.ORT
    ? selectedLocation.ORT.trim().toLowerCase()
    : "";

  useEffect(() => {
    const fetchStaffDiscountArticles = async () => {
      setArticlesList([]);
      setError("");
      setNoticeModal({
        open: false,
        message: "",
      });

      /*
       * Wenn noch keine Filiale gewählt wurde,
       * Popup anzeigen.
       *
       * Kein return mehr:
       * Der Backend-Aufruf wird trotzdem ausgeführt,
       * damit availableBranches geladen werden können.
       */
      // if (!selectedLocationName) {
      //   setNoticeModal({
      //     open: true,
      //     message:
      //       "Bitte wählen Sie zunächst eine Filiale aus, um die verfügbaren Produkte der Personalkauftage anzuzeigen.",
      //   });
      // }

      setLoading(true);

      try {
        const response = await fetch(
          `${apiConfig.apiBasePath}getStaffDiscountArticles`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              branch: selectedLocationName,
            }),
          },
        );

        if (!response.ok) {
          throw new Error("Personalkauftage konnten nicht geladen werden.");
        }

        const result = await response.json();

        /*
         * Verfügbare Personalkauftage-Filialen
         * direkt aus dem Backend übernehmen.
         */
        const branches = Array.isArray(result?.availableBranches)
          ? result.availableBranches
          : [];

        setAvailableBranches(branches);

        /*
         * Wenn genau eine Personalkauftage-Filiale verfügbar ist,
         * diese automatisch auswählen.
         *
         * Kein Popup anzeigen.
         */
        if (branches.length === 1) {
          const onlyBranch = branches[0];

          const onlyBranchName = String(onlyBranch?.name || "")
            .trim()
            .toLowerCase();

          const onlyBranchValue = String(onlyBranch?.value || "")
            .trim()
            .toLowerCase();

          /*
           * Nur wechseln, wenn diese Filiale
           * noch nicht ausgewählt ist.
           */
          if (
            selectedLocationName !== onlyBranchName &&
            selectedLocationName !== onlyBranchValue
          ) {
            await handleStaffDiscountLocationChange(onlyBranch.value, branches);

            return;
          }

          /*
           * Filiale ist bereits korrekt gewählt.
           * Popup sicher geschlossen halten.
           */
          setNoticeModal({
            open: false,
            message: "",
          });
        }

        /*
         * Wenn mehrere Personalkauftage-Filialen vorhanden sind
         * und noch keine Filiale gewählt wurde,
         * Auswahl-Popup anzeigen.
         */
        if (!selectedLocationName && branches.length > 1) {
          setNoticeModal({
            open: true,
            message:
              "Bitte wählen Sie zunächst eine Filiale aus, um die verfügbaren Produkte der Personalkauftage anzuzeigen.",
          });

          return;
        }

        if (
          result?.status === "unavailable" &&
          result?.code === "BRANCH_NOT_CONFIGURED"
        ) {
          setNoticeModal({
            open: true,
            message: selectedLocationName
              ? result?.message ||
                "Für die ausgewählte Filiale sind derzeit keine Produkte verfügbar. Bitte wählen Sie eine andere Filiale."
              : "Bitte wählen Sie zunächst eine Filiale aus, um die verfügbaren Produkte der Personalkauftage anzuzeigen.",
          });

          return;
        }

        if (result?.status !== "success" || !Array.isArray(result?.data)) {
          throw new Error(
            result?.message || "Personalkauftage konnten nicht geladen werden.",
          );
        }

        if (result.data.length === 0) {
          setNoticeModal({
            open: true,
            message:
              "Für die ausgewählte Filiale sind derzeit keine Produkte verfügbar. Bitte wählen Sie eine andere Filiale.",
          });

          return;
        }

        /*
         * Neue Personalkauftage API-Struktur
         * auf die bestehende Artikel-Struktur mappen.
         *
         * Dadurch können BrandArticles, ArticlesSearch,
         * ArticleDetail und Pagination unverändert weiterverwendet werden.
         */
        const mappedArticles = result.data.map((article) => ({
          ARTIKELNR: article?.Artikelnummer || "",
          EAN: article?.EAN || "",
          BEZEICHNUNG: article?.Bezeichnung || "",

          BESCHREIBUNG_KURZ_ORIGINAL: "",
          BESCHREIBUNG_LANG: "",

          images: article?.Bildpfad || "",

          HERSTELLER_ID: article?.Hersteller || "",
          brandName: article?.Hersteller || "",
          brandImg: article?.Herstellerlogo || "",

          WARENGRUPPEN_ID: article?.Warengruppe || "",
          cat: article?.Warengruppe || "",

          VK: parseFloat(article?.["End-VK"]) || 0,
        }));

        setArticlesList(mappedArticles);

        console.log("Personalkauftage Filiale:", selectedLocationName);
        console.log("Personalkauftage API:", result);
        console.log("Personalkauftage Artikel:", mappedArticles);
      } catch (error) {
        console.error("Personalkauftage Fehler:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchStaffDiscountArticles();
  }, [selectedLocationName]);

  /*
   * Filiale direkt aus dem Popup auswählen.
   *
   * Zusätzlich zur Personalkauftage-Auswahl
   * wird auch der globale Standort
   * für den Header aktualisiert.
   */
  const handleStaffDiscountLocationChange = async (
    branchValue,
    branchList = availableBranches,
  ) => {
    /*
     * Leere "Bitte Filiale auswählen" Option:
     * Keine Änderung durchführen.
     */
    if (!branchValue) {
      return;
    }

    const selectedBranch = branchList.find(
      (branch) => branch.value === branchValue,
    );

    if (!selectedBranch) {
      return;
    }

    /*
     * Personalkauftage sofort auf die
     * ausgewählte Filiale umstellen.
     */
    setSelectedLocation({
      ORT: selectedBranch.name,
    });

    setNoticeModal({
      open: false,
      message: "",
    });

    /*
     * Vollständigen Standort aus der bestehenden
     * locationList laden.
     */
    try {
      const response = await fetch(`${apiConfig.apiBasePath}locationList`);

      if (!response.ok) {
        throw new Error("Standort konnte nicht geladen werden.");
      }

      const locations = await response.json();

      const selectedGlobalLocation = Array.isArray(locations)
        ? locations.find(
            (location) =>
              location?.ORT &&
              (location.ORT.trim().toLowerCase() ===
                selectedBranch.value.trim().toLowerCase() ||
                location.ORT.trim().toLowerCase() ===
                  selectedBranch.name.trim().toLowerCase()),
          )
        : null;

      if (!selectedGlobalLocation) {
        console.error(
          "Personalkauftage Standort nicht in locationList gefunden:",
          selectedBranch,
        );

        return;
      }

      /*
       * Gleiche Standort-Aktualisierung
       * wie im bestehenden Header.
       */
      localStorage.setItem(
        "selectLocation",
        JSON.stringify(selectedGlobalLocation),
      );

      /*
       * Header-Anzeige sofort aktualisieren.
       *
       * Der Header liest localStorage erst
       * bei seinem nächsten React-Render.
       * Deshalb hier nur den sichtbaren
       * Standort direkt aktualisieren.
       */
      const headerLocationText = document.querySelector(
        ".locationBtn .locationToggle span",
      );

      if (headerLocationText) {
        headerLocationText.textContent = selectedGlobalLocation.ORT;
      }

      dispatch(fetchLocationInfo(selectedGlobalLocation));

      window.dispatchEvent(
        new CustomEvent("technikkennerLocationChanged", {
          detail: selectedGlobalLocation,
        }),
      );

      /*
       * Auch lokal den vollständigen Standort setzen.
       */
      setSelectedLocation(selectedGlobalLocation);
    } catch (error) {
      console.error(
        "Personalkauftage Standort konnte nicht aktualisiert werden:",
        error,
      );
    }
  };

  return (
    <>
      <StaffDiscountNoticeModal
        isOpen={noticeModal.open}
        message={noticeModal.message}
        availableBranches={availableBranches}
        onLocationChange={handleStaffDiscountLocationChange}
        onClose={() =>
          setNoticeModal({
            open: false,
            message: "",
          })
        }
      />

      <section className="innerPageBanner">
        <img
          className="d-none d-md-block"
          src="assets/images/A14010_10228_Personalkauftage_Headergrafik-1920x486px_v2.jpg"
          alt=""
        />
      </section>

      <div className="categorySection">
        <div className="container">
          <div className="row">
            {loading && (
              <div className="col-12 text-center text-white py-5">
                Personalkauftage werden geladen...
              </div>
            )}

            {!loading && error && (
              <div className="col-12 text-center text-white py-5">{error}</div>
            )}

            {!loading && !error && ArticlesList.length > 0 && (
              <BrandArticles
                key={selectedLocationName}
                cat={cat}
                ArticlesList={ArticlesList}
                filterSave={filter}
                staffDiscount={true}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default StaffDiscount;
